import { Record } from 'immutable';
import { schema } from 'normalizr';

export const SiteConfiguration = new Record({
  id: undefined,
  site: undefined,
  tag_number: undefined,
  utility_company: undefined,
  utility_meter_number: undefined,
  utility_account_number: undefined,
  digital_vendor: null,
  third_party_access_allowed: true,
  third_party_vendors: null,
  ignore_window_enabled: null,
  ignore_window_start_time: null,
  ignore_window_end_time: null,
});

export const siteConfigurationSchema = new schema.Entity('siteConfigurations');

// for reading in nested models, object with { field: schema }
// siteConfigurationSchema.define({  });
